import { render, staticRenderFns } from "./ObjectManagement.vue?vue&type=template&id=418babdc&scoped=true&"
import script from "./ObjectManagement.vue?vue&type=script&lang=js&"
export * from "./ObjectManagement.vue?vue&type=script&lang=js&"
import style0 from "./ObjectManagement.vue?vue&type=style&index=0&id=418babdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418babdc",
  null
  
)

export default component.exports